import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'

const confirmDelete = (deleteAttachment, deleteFn) => {
  const deleteAttachmentPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Attachment Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete File?',
    }).then(({ value }) => {
      if (value){
        deleteAttachment(deleteAttachmentPayload)
      }
    })
}

const AssetListItem = (props) => {
  const { attachment, callbacks: { deleteAttachment } } = props

  const {
    dates: {
      created: {
        date,
      },
    },
    file_file_name,
  } = attachment

  const {
    callbacks: {
      deleteAttachment: deleteFn,
      downloadAttachment,
    },
  } = useAttachment(attachment)

  return (
    <DashboardModuleListItem
      isSidebar
      secondaryText={`Uploaded ${date}`}
      title={file_file_name}
    >
      <DashboardModuleListItem.Actions>
        <Link
          greyLink
          onClick={e => downloadAttachment(e)}
          textProps={{ marginRight: 'medium' }}
        >
          <FontAwesomeIcon icon={faFileDownload} />
        </Link>

        <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteAttachment, deleteFn)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

AssetListItem.propTypes = {
  attachment: PropTypes.object.isRequired,
  callbacks: PropTypes.shape({
    deleteAttachment: PropTypes.func.isRequired,
  }).isRequired,
}

export default AssetListItem
